import { includes } from 'lodash';
import { useReducer } from 'react';

export default function useFilters(shape: any, onFilterChange: (filters: any) => void) {
  const [filters, setFilters] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), shape);

  const toggle = (key: string) => (value: any) => {
    if (filters[key].includes(value)) {
      return filters[key].filter((item: any) => item !== value);
    }
    return [...filters[key], value];
  };

  const reset = (shapeToReset: any = false) => {
    setFilters(shapeToReset || shape);
    if (onFilterChange) {
      onFilterChange(shapeToReset || shape);
    }
  };

  const makeUpdaterMethod = (key: string) => (value: string | Array<string>, totalItems?: number) => {
    if (Array.isArray(value)) {
      setFilters({ [key]: value });
      if (onFilterChange) {
        onFilterChange({ ...filters, [key]: value });
      }
    } else {
      setFilters({
        [key]: Array.isArray(filters[key]) ? toggle(key)(value) : value,
      });

      if (onFilterChange) {
        let changedFilterValue = Array.isArray(filters[key]) ? toggle(key)(value) : value;

        // fix a bug when all items were selected manually.
        if (includes(changedFilterValue, 'all') && changedFilterValue.length > 1) {
          // Verify if the number of checked item is the same than the total of items
          // it means user checked all or unchecked all
          if (totalItems && changedFilterValue.length === totalItems + 1) {
            // return an empty array that is the same behavior when user click to deselect all items
            changedFilterValue = [];
          }
        }

        onFilterChange({
          ...filters,
          [key]: changedFilterValue,
        });
      }
    }
  };

  const makeCleanerMethod = (key: string) => {
    setFilters({
      [key]: Array.isArray(filters[key]) ? [] : null,
    });
    if (onFilterChange) {
      onFilterChange({ ...filters, [key]: Array.isArray(filters[key]) ? [] : null });
    }
  };

  const makeSelectAllMethod = (key: string) => {
    setFilters({
      [key]: filters[key].includes('all') && filters[key].length === 1 ? [] : ['all'],
    });
    if (onFilterChange) {
      onFilterChange({ ...filters, [key]: filters[key].includes('all') && filters[key].length === 1 ? [] : ['all'] });
    }
  };

  return {
    filters,
    updater: makeUpdaterMethod,
    cleaner: makeCleanerMethod,
    selectAll: makeSelectAllMethod,
    reset,
  };
}
